export const Dashboard = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 26C13.3333 26.7373 13.9293 27.3333 14.6667 27.3333H18.6667C20.0813 27.3333 21.4373 26.772 22.4373 25.772C23.4373 24.772 24 23.4147 24 22C24 21.2347 24 20.6667 24 20.6667C24 19.9307 23.4027 19.3333 22.6667 19.3333H14.6667C13.9293 19.3333 13.3333 19.9307 13.3333 20.6667V26ZM9.33333 27.3333C10.0693 27.3333 10.6667 26.7373 10.6667 26V12.6667C10.6667 11.9307 10.0693 11.3333 9.33333 11.3333H1.33333C0.596 11.3333 0 11.9307 0 12.6667V22C0 23.4147 0.56133 24.772 1.56133 25.772C2.56133 26.772 3.91867 27.3333 5.33333 27.3333H9.33333ZM21.3333 22H16V24.6667H18.6667C19.3733 24.6667 20.052 24.3866 20.552 23.8866C21.052 23.3866 21.3333 22.708 21.3333 22ZM8 24.6667V14H2.66667V22C2.66667 22.708 2.94666 23.3866 3.448 23.8866C3.948 24.3866 4.62533 24.6667 5.33333 24.6667H8ZM14.6667 0.666656C13.9293 0.666656 13.3333 1.26399 13.3333 1.99999V15.3333C13.3333 16.0707 13.9293 16.6667 14.6667 16.6667H22.6667C23.4027 16.6667 24 16.0707 24 15.3333V5.99999C24 4.58666 23.4373 3.22932 22.4373 2.22932C21.4373 1.22932 20.0813 0.666656 18.6667 0.666656H14.6667ZM16 3.33332V14H21.3333V5.99999C21.3333 5.29332 21.052 4.61465 20.552 4.11465C20.052 3.61465 19.3733 3.33332 18.6667 3.33332H16ZM10.6667 1.99999C10.6667 1.26399 10.0693 0.666656 9.33333 0.666656H5.33333C3.91867 0.666656 2.56133 1.22932 1.56133 2.22932C0.56133 3.22932 0 4.58666 0 5.99999V7.33332C0 8.07066 0.596 8.66666 1.33333 8.66666H9.33333C10.0693 8.66666 10.6667 8.07066 10.6667 7.33332V1.99999ZM8 3.33332H5.33333C4.62533 3.33332 3.948 3.61465 3.448 4.11465C2.94666 4.61465 2.66667 5.29332 2.66667 5.99999H8V3.33332Z"
      />
    </svg>
  );
};
// export const Home = ({ fillColor }) => {
//   return (
//     <svg
//       width="20"
//       height="22"
//       viewBox="0 0 20 22"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M1.83325 10.8862C1.83325 9.30215 1.83325 8.51013 2.15346 7.81393C2.47366 7.11773 3.07501 6.60229 4.27771 5.5714L5.44438 4.5714C7.61825 2.70809 8.70519 1.77643 9.99992 1.77643C11.2947 1.77643 12.3816 2.70809 14.5555 4.5714L15.7221 5.5714C16.9248 6.60229 17.5262 7.11773 17.8464 7.81393C18.1666 8.51013 18.1666 9.30215 18.1666 10.8862V15.8333C18.1666 18.0332 18.1666 19.1332 17.4832 19.8166C16.7998 20.5 15.6998 20.5 13.4999 20.5H6.49992C4.30003 20.5 3.20009 20.5 2.51667 19.8166C1.83325 19.1332 1.83325 18.0332 1.83325 15.8333V10.8862Z"
//         stroke={fillColor}
//         strokeWidth="2"
//       />
//       <path
//         d="M12.9166 20.5V14.5C12.9166 13.9477 12.4689 13.5 11.9166 13.5H8.08325C7.53097 13.5 7.08325 13.9477 7.08325 14.5V20.5"
//         stroke={fillColor}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// };
export const Clients = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 22 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6593 21.5589C20.0895 19.9641 18.8341 18.5549 17.0876 17.5499C15.3412 16.5448 13.2013 16 11 16C8.79866 16 6.65883 16.5448 4.91239 17.5498C3.16595 18.5549 1.91049 19.9641 1.34074 21.5589"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="11"
        cy="6"
        r="5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const GlobalFund = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.70178"
        width="21"
        height="13.4035"
        rx="2"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M5 5.05261L7.33333 5.05261"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.6667 11.7544H19.0001"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.5 8.40349C14.5 9.66125 13.4222 10.7544 12 10.7544C10.5778 10.7544 9.5 9.66125 9.5 8.40349C9.5 7.14572 10.5778 6.05261 12 6.05261C13.4222 6.05261 14.5 7.14572 14.5 8.40349Z"
        stroke={fillColor}
        strokeWidth="2"
      />
    </svg>
  );
};
export const Portfolio = ({ fillColor }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11.5"
        cy="11.5002"
        r="10.5"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M12 12.0002H22"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 1.00024V11.7393C12 11.7784 12.0152 11.8159 12.0425 11.8439L19 19.0002"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const IFAs = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="12"
        cy="9.74396"
        rx="3.5"
        ry="3.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="12"
        cy="12.0773"
        r="10.5"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M18.7439 20.0414C18.8923 19.96 18.9624 19.7837 18.8997 19.6265C18.4498 18.4992 17.5832 17.5063 16.4117 16.7827C15.146 16.001 13.5953 15.5773 12 15.5773C10.4047 15.5773 8.85398 16.001 7.58835 16.7827C6.41684 17.5063 5.5502 18.4992 5.10031 19.6265C5.03761 19.7837 5.10775 19.96 5.25606 20.0414C9.45633 22.3474 14.5437 22.3474 18.7439 20.0414Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const Reports = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 20.5H1.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M2.66675 14.6666V12.3333"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 10V6.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.33325 14.6667V7.66669"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.6667 11.1666V8.83331"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.3333 13.5V1.83331"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const Maintenance = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.41494 13.9448C1.88623 12.9943 1.62187 12.5191 1.62187 12.0003C1.62187 11.4814 1.88623 11.0062 2.41494 10.0558L4.16935 6.90193L6.02344 3.80565C6.58219 2.87256 6.86156 2.40601 7.31089 2.14659C7.76022 1.88716 8.30396 1.87849 9.39142 1.86115L12.9999 1.8036L16.6084 1.86115C17.6959 1.87849 18.2396 1.88716 18.6889 2.14659C19.1383 2.40601 19.4176 2.87255 19.9764 3.80565L21.8305 6.90193L23.5849 10.0558C24.1136 11.0062 24.378 11.4814 24.378 12.0003C24.378 12.5191 24.1136 12.9943 23.5849 13.9448L21.8305 17.0986L19.9764 20.1949C19.4176 21.128 19.1383 21.5945 18.6889 21.8539C18.2396 22.1134 17.6959 22.122 16.6084 22.1394L12.9999 22.1969L9.39142 22.1394C8.30396 22.122 7.76023 22.1134 7.3109 21.8539C6.86157 21.5945 6.58219 21.128 6.02344 20.1949L4.16935 17.0986L2.41494 13.9448Z"
        stroke={fillColor}
        strokeWidth="2"
      />
      <circle cx="13" cy="12.0002" r="3.5" stroke={fillColor} strokeWidth="2" />
    </svg>
  );
};
export const Dropdown = ({ fillColor }) => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Cross = ({ fillColor, handleClose }) => {
  return (
    <svg
      width="21"
      height="21"
      onClick={() => handleClose()}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3651 5.46033L5.46033 15.3651"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46029 5.46033L15.3651 15.3651"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const User = ({ fillColor }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.117188 16.0419C0.117188 7.43355 7.09566 0.455078 15.704 0.455078C24.3124 0.455078 31.2909 7.43355 31.2909 16.0419C31.2909 20.5702 29.3599 24.6475 26.2764 27.4952C25.5257 25.575 24.2627 23.8875 22.6144 22.6227C20.6318 21.1014 18.2027 20.2769 15.7037 20.2769C13.2047 20.2769 10.7755 21.1014 8.79295 22.6227C7.14484 23.8874 5.88191 25.5747 5.13113 27.4947C2.04796 24.647 0.117188 20.5699 0.117188 16.0419ZM22.8053 29.7261C22.8206 29.7832 22.8382 29.8391 22.858 29.8937C20.7155 31.0025 18.2829 31.6288 15.704 31.6288C13.1249 31.6288 10.6921 31.0024 8.54942 29.8934C8.5692 29.8389 8.5868 29.7831 8.60208 29.7261C9.02097 28.1628 9.94399 26.7814 11.228 25.7961C12.512 24.8109 14.0852 24.2769 15.7037 24.2769C17.3221 24.2769 18.8954 24.8109 20.1794 25.7961C21.4634 26.7814 22.3864 28.1628 22.8053 29.7261ZM13.0283 11.366C13.0283 9.88805 14.2264 8.68994 15.7044 8.68994C17.1823 8.68994 18.3804 9.88805 18.3804 11.366C18.3804 12.8439 17.1823 14.0421 15.7044 14.0421C14.2264 14.0421 13.0283 12.8439 13.0283 11.366ZM15.7044 4.68994C12.0173 4.68994 9.02832 7.67891 9.02832 11.366C9.02832 15.0531 12.0173 18.0421 15.7044 18.0421C19.3915 18.0421 22.3804 15.0531 22.3804 11.366C22.3804 7.67891 19.3915 4.68994 15.7044 4.68994Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const Download = ({ fillColor }) => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49642 17.3741C2.15199 19.5052 3.59656 21.3882 5.60608 22.7312C7.6156 24.0743 10.0778 24.8022 12.6107 24.8022C15.1436 24.8022 17.6058 24.0743 19.6153 22.7312C21.6249 21.3882 23.0694 19.5052 23.725 17.3741"
        stroke={fillColor}
        strokeWidth="3"
      />
      <path
        d="M12.6107 14.7803L11.7531 16.011L12.6107 16.6085L13.4682 16.011L12.6107 14.7803ZM14.1107 1.89489C14.1107 1.06646 13.4391 0.394887 12.6107 0.394887C11.7822 0.394887 11.1107 1.06646 11.1107 1.89489L14.1107 1.89489ZM3.5343 10.2841L11.7531 16.011L13.4682 13.5496L5.24939 7.82274L3.5343 10.2841ZM13.4682 16.011L21.6871 10.2841L19.972 7.82274L11.7531 13.5496L13.4682 16.011ZM14.1107 14.7803L14.1107 1.89489L11.1107 1.89489L11.1107 14.7803L14.1107 14.7803Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const IcCheck = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="17"
        height="17"
        rx="2"
        stroke={fillColor}
        strokeWidth="2"
      />
    </svg>
  );
};

export const DateRange = ({ fillColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="6"
        width="18"
        height="15"
        rx="2"
        stroke="#0B6AAB"
        strokeWidth="2"
      />
      <path
        d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z"
        fill={fillColor}
      />
      <path
        d="M7 3L7 6"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17 3L17 6"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect x="7" y="12" width="4" height="2" rx="0.5" fill={fillColor} />
      <rect x="7" y="16" width="4" height="2" rx="0.5" fill={fillColor} />
      <rect x="13" y="12" width="4" height="2" rx="0.5" fill={fillColor} />
      <rect x="13" y="16" width="4" height="2" rx="0.5" fill={fillColor} />
    </svg>
  );
};

export const Refresh = ({ fillColor }) => {
  return (
    <svg
      width="40"
      height="35"
      viewBox="0 0 40 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4606 27.3599L15.4754 26.2288L14.1767 27.3599L15.4754 28.491L16.4606 27.3599ZM22.0504 20.5019L15.4754 26.2288L17.4458 28.491L24.0208 22.7642L22.0504 20.5019ZM15.4754 28.491L22.0504 34.2178L24.0208 31.9556L17.4458 26.2288L15.4754 28.491Z"
        fill={fillColor}
      />
      <path
        d="M9.78335 22.3489C8.51688 20.4383 8.00962 18.2171 8.34023 16.0298C8.67085 13.8425 9.82087 11.8113 11.6119 10.2513C13.403 8.69128 15.735 7.68962 18.2463 7.40166C20.7575 7.11369 23.3077 7.55552 25.5013 8.65861C27.6949 9.7617 29.4093 11.4644 30.3786 13.5027C31.348 15.5409 31.518 17.8008 30.8624 19.9318C30.2069 22.0628 28.7623 23.9458 26.7528 25.2889C24.7433 26.6319 22.2811 27.3599 19.7482 27.3599"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Previous = ({ fillColor }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.46973 12.8296L4.25505 8.61491L8.46973 4.40024"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3867 12.8296L9.17204 8.61491L13.3867 4.40024"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Next = ({ fillColor }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.52246 12.8296L12.7371 8.61491L8.52246 4.40024"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.60547 12.8296L7.82014 8.61491L3.60547 4.40024"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LeftArrow = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.21484 8.5L1.4568 7.8478L0.895666 8.5L1.4568 9.1522L2.21484 8.5ZM18.3467 9.5C18.899 9.5 19.3467 9.05229 19.3467 8.5C19.3467 7.94772 18.899 7.5 18.3467 7.5V9.5ZM7.90954 0.347801L1.4568 7.8478L2.97289 9.1522L9.42564 1.6522L7.90954 0.347801ZM1.4568 9.1522L7.90954 16.6522L9.42564 15.3478L2.97289 7.8478L1.4568 9.1522ZM2.21484 9.5H18.3467V7.5H2.21484V9.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const SearchIcon = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1132 12.9051C9.31712 15.1406 5.2242 14.9647 2.63221 12.3773C-0.148889 9.60106 -0.148889 5.09994 2.63221 2.32373C5.41332 -0.452475 9.92237 -0.452474 12.7035 2.32373C15.2955 4.91115 15.4717 8.99686 13.2323 11.788L18.6716 17.2178C18.9806 17.5263 18.9806 18.0264 18.6716 18.3349C18.3626 18.6434 17.8616 18.6434 17.5526 18.3349L12.1132 12.9051ZM3.75124 11.2602C1.58816 9.10093 1.58816 5.60006 3.75124 3.44079C5.91432 1.28152 9.42137 1.28152 11.5844 3.44079C13.7459 5.59848 13.7475 9.09579 11.5892 11.2554C11.5876 11.257 11.586 11.2586 11.5844 11.2602C11.5828 11.2618 11.5813 11.2634 11.5797 11.2649C9.41623 13.4195 5.91274 13.4179 3.75124 11.2602Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const DropdownIcon2 = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width ? width : "20"}
      height={height ? height : "13"}
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10L11.0607 11.0607L10 12.1213L8.93934 11.0607L10 10ZM19.0607 3.06066L11.0607 11.0607L8.93934 8.93934L16.9393 0.939339L19.0607 3.06066ZM8.93934 11.0607L0.93934 3.06066L3.06066 0.939339L11.0607 8.93934L8.93934 11.0607Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Right = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="11"
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4573 5.03388C19.4571 5.03365 19.4569 5.03339 19.4566 5.03316L15.519 1.09782C15.224 0.803008 14.7469 0.804105 14.4533 1.10039C14.1597 1.39664 14.1608 1.87581 14.4558 2.17065L17.0995 4.81278H1.1403C0.724095 4.81278 0.386719 5.1516 0.386719 5.56958C0.386719 5.98756 0.724095 6.32638 1.1403 6.32638H17.0994L14.4558 8.96851C14.1608 9.26335 14.1597 9.74252 14.4533 10.0388C14.7469 10.3351 15.2241 10.3361 15.519 10.0413L19.4566 6.106C19.4569 6.10577 19.4571 6.10551 19.4573 6.10528C19.7525 5.80945 19.7515 5.32873 19.4573 5.03388Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Dotted = ({ fillColor }) => {
  return (
    <svg
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.32182 1.39569C2.32182 2.02129 1.82699 2.52844 1.21657 2.52844C0.606164 2.52844 0.111328 2.02129 0.111328 1.39569C0.111328 0.770089 0.606164 0.262939 1.21657 0.262939C1.82699 0.262939 2.32182 0.770089 2.32182 1.39569Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M7.47964 1.39569C7.47964 2.02129 6.9848 2.52844 6.37439 2.52844C5.76398 2.52844 5.26915 2.02129 5.26915 1.39569C5.26915 0.770089 5.76398 0.262939 6.37439 0.262939C6.9848 0.262939 7.47964 0.770089 7.47964 1.39569Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M12.6375 1.39569C12.6375 2.02129 12.1426 2.52844 11.5322 2.52844C10.9218 2.52844 10.427 2.02129 10.427 1.39569C10.427 0.770089 10.9218 0.262939 11.5322 0.262939C12.1426 0.262939 12.6375 0.770089 12.6375 1.39569Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M17.7953 1.39569C17.7953 2.02129 17.3004 2.52844 16.69 2.52844C16.0796 2.52844 15.5848 2.02129 15.5848 1.39569C15.5848 0.770089 16.0796 0.262939 16.69 0.262939C17.3004 0.262939 17.7953 0.770089 17.7953 1.39569Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M2.32182 6.68185C2.32182 7.30745 1.82699 7.8146 1.21657 7.8146C0.606164 7.8146 0.111328 7.30745 0.111328 6.68185C0.111328 6.05625 0.606164 5.5491 1.21657 5.5491C1.82699 5.5491 2.32182 6.05625 2.32182 6.68185Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M7.47964 6.68185C7.47964 7.30745 6.9848 7.8146 6.37439 7.8146C5.76398 7.8146 5.26915 7.30745 5.26915 6.68185C5.26915 6.05625 5.76398 5.5491 6.37439 5.5491C6.9848 5.5491 7.47964 6.05625 7.47964 6.68185Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M12.6375 6.68185C12.6375 7.30745 12.1426 7.8146 11.5322 7.8146C10.9218 7.8146 10.427 7.30745 10.427 6.68185C10.427 6.05625 10.9218 5.5491 11.5322 5.5491C12.1426 5.5491 12.6375 6.05625 12.6375 6.68185Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M17.7953 6.68185C17.7953 7.30745 17.3004 7.8146 16.69 7.8146C16.0796 7.8146 15.5848 7.30745 15.5848 6.68185C15.5848 6.05625 16.0796 5.5491 16.69 5.5491C17.3004 5.5491 17.7953 6.05625 17.7953 6.68185Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M2.32182 11.968C2.32182 12.5936 1.82699 13.1008 1.21657 13.1008C0.606164 13.1008 0.111328 12.5936 0.111328 11.968C0.111328 11.3424 0.606164 10.8353 1.21657 10.8353C1.82699 10.8353 2.32182 11.3424 2.32182 11.968Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M7.47964 11.968C7.47964 12.5936 6.9848 13.1008 6.37439 13.1008C5.76398 13.1008 5.26915 12.5936 5.26915 11.968C5.26915 11.3424 5.76398 10.8353 6.37439 10.8353C6.9848 10.8353 7.47964 11.3424 7.47964 11.968Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M12.6375 11.968C12.6375 12.5936 12.1426 13.1008 11.5322 13.1008C10.9218 13.1008 10.427 12.5936 10.427 11.968C10.427 11.3424 10.9218 10.8353 11.5322 10.8353C12.1426 10.8353 12.6375 11.3424 12.6375 11.968Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M17.7953 11.968C17.7953 12.5936 17.3004 13.1008 16.69 13.1008C16.0796 13.1008 15.5848 12.5936 15.5848 11.968C15.5848 11.3424 16.0796 10.8353 16.69 10.8353C17.3004 10.8353 17.7953 11.3424 17.7953 11.968Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M2.32182 17.2542C2.32182 17.8798 1.82699 18.3869 1.21657 18.3869C0.606164 18.3869 0.111328 17.8798 0.111328 17.2542C0.111328 16.6286 0.606164 16.1214 1.21657 16.1214C1.82699 16.1214 2.32182 16.6286 2.32182 17.2542Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M7.47964 17.2542C7.47964 17.8798 6.9848 18.3869 6.37439 18.3869C5.76398 18.3869 5.26915 17.8798 5.26915 17.2542C5.26915 16.6286 5.76398 16.1214 6.37439 16.1214C6.9848 16.1214 7.47964 16.6286 7.47964 17.2542Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M12.6375 17.2542C12.6375 17.8798 12.1426 18.3869 11.5322 18.3869C10.9218 18.3869 10.427 17.8798 10.427 17.2542C10.427 16.6286 10.9218 16.1214 11.5322 16.1214C12.1426 16.1214 12.6375 16.6286 12.6375 17.2542Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M17.7953 17.2542C17.7953 17.8798 17.3004 18.3869 16.69 18.3869C16.0796 18.3869 15.5848 17.8798 15.5848 17.2542C15.5848 16.6286 16.0796 16.1214 16.69 16.1214C17.3004 16.1214 17.7953 16.6286 17.7953 17.2542Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M2.32182 22.5403C2.32182 23.1659 1.82699 23.6731 1.21657 23.6731C0.606164 23.6731 0.111328 23.1659 0.111328 22.5403C0.111328 21.9147 0.606164 21.4076 1.21657 21.4076C1.82699 21.4076 2.32182 21.9147 2.32182 22.5403Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M7.47964 22.5403C7.47964 23.1659 6.9848 23.6731 6.37439 23.6731C5.76398 23.6731 5.26915 23.1659 5.26915 22.5403C5.26915 21.9147 5.76398 21.4076 6.37439 21.4076C6.9848 21.4076 7.47964 21.9147 7.47964 22.5403Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M12.6375 22.5403C12.6375 23.1659 12.1426 23.6731 11.5322 23.6731C10.9218 23.6731 10.427 23.1659 10.427 22.5403C10.427 21.9147 10.9218 21.4076 11.5322 21.4076C12.1426 21.4076 12.6375 21.9147 12.6375 22.5403Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
      <path
        d="M17.7953 22.5403C17.7953 23.1659 17.3004 23.6731 16.69 23.6731C16.0796 23.6731 15.5848 23.1659 15.5848 22.5403C15.5848 21.9147 16.0796 21.4076 16.69 21.4076C17.3004 21.4076 17.7953 21.9147 17.7953 22.5403Z"
        fill={fillColor}
        fillOpacity="0.5"
      />
    </svg>
  );
};

export const AddClient = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="8.0845"
        cy="7.32718"
        rx="3.23392"
        ry="3.23392"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.7708 17.3905C12.4945 16.3591 11.8855 15.4476 11.0383 14.7976C10.1911 14.1475 9.1531 13.7952 8.08525 13.7952C7.01741 13.7952 5.9794 14.1475 5.13223 14.7976C4.28505 15.4476 3.67604 16.3591 3.39966 17.3905"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15.3613 8.94409L15.3613 13.795"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.7861 11.3696L12.9353 11.3696"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const Call = ({ fillColor }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0114 15.2624V18.1301C20.0124 18.3963 19.9579 18.6598 19.8513 18.9038C19.7446 19.1477 19.5882 19.3667 19.392 19.5466C19.1958 19.7266 18.9642 19.8636 18.712 19.9489C18.4598 20.0342 18.1926 20.0659 17.9275 20.0419C14.986 19.7223 12.1604 18.7172 9.67791 17.1073C7.36826 15.6396 5.41007 13.6814 3.94242 11.3718C2.3269 8.87799 1.32153 6.03872 1.00776 3.08399C0.983871 2.81965 1.01529 2.55323 1.10001 2.30169C1.18472 2.05016 1.32089 1.81902 1.49983 1.62299C1.67877 1.42696 1.89657 1.27034 2.13936 1.1631C2.38215 1.05586 2.64461 1.00034 2.91003 1.00009H5.77778C6.24169 0.995527 6.69143 1.15981 7.04318 1.46231C7.39493 1.76481 7.62468 2.1849 7.68961 2.64427C7.81065 3.56201 8.03512 4.46311 8.35875 5.33039C8.48736 5.67254 8.5152 6.04438 8.43896 6.40186C8.36272 6.75934 8.1856 7.08747 7.92859 7.34737L6.71458 8.56139C8.07537 10.9546 10.0569 12.9361 12.4501 14.2969L13.6641 13.0829C13.924 12.8259 14.2521 12.6487 14.6096 12.5725C14.9671 12.4963 15.3389 12.5241 15.6811 12.6527C16.5483 12.9763 17.4494 13.2008 18.3672 13.3218C18.8315 13.3874 19.2556 13.6212 19.5588 13.979C19.8619 14.3368 20.023 14.7935 20.0114 15.2624Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Email = ({ fillColor }) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.98246 1H18.8421C19.9325 1 20.8246 1.89211 20.8246 2.98246V14.8772C20.8246 15.9675 19.9325 16.8596 18.8421 16.8596H2.98246C1.89211 16.8596 1 15.9675 1 14.8772V2.98246C1 1.89211 1.89211 1 2.98246 1Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8323 2.98218L10.9113 9.67297L1.99023 2.98218"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Fax = ({ fillColor }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2751 13.2665H18.0811C19.024 13.2665 19.4954 13.2665 19.7883 12.9736C20.0811 12.6807 20.0811 12.2093 20.0811 11.2665V9.08887C20.0811 7.20325 20.0811 6.26044 19.4954 5.67465C18.9096 5.08887 17.9668 5.08887 16.0811 5.08887H5C3.11438 5.08887 2.17157 5.08887 1.58579 5.67465C1 6.26044 1 7.20325 1 9.08887V12.2665C1 12.7379 1 12.9736 1.14645 13.1201C1.29289 13.2665 1.5286 13.2665 2 13.2665H3.80605"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M4.40723 20.069L4.40723 10.4962C4.40723 9.55344 4.40723 9.08203 4.70012 8.78914C4.99301 8.49624 5.46442 8.49624 6.40723 8.49624L14.6737 8.49624C15.6165 8.49624 16.0879 8.49624 16.3808 8.78914C16.6737 9.08203 16.6737 9.55344 16.6737 10.4962L16.6737 20.069C16.6737 20.3855 16.6737 20.5438 16.5699 20.6186C16.466 20.6935 16.3159 20.6434 16.0156 20.5433L13.502 19.7055C13.4161 19.6768 13.3731 19.6625 13.3288 19.6638C13.2844 19.6651 13.2424 19.6819 13.1582 19.7156L10.7261 20.6884C10.6344 20.7251 10.5886 20.7434 10.5404 20.7434C10.4923 20.7434 10.4465 20.7251 10.3548 20.6884L7.92267 19.7156C7.83854 19.6819 7.79647 19.6651 7.75214 19.6638C7.70782 19.6625 7.66483 19.6768 7.57887 19.7055L5.06534 20.5433C4.76503 20.6434 4.61487 20.6935 4.51105 20.6186C4.40723 20.5438 4.40723 20.3855 4.40723 20.069Z"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M8.83691 12.2444L11.5628 12.2444"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.83691 15.6516L12.2443 15.6516"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.6737 5.08882V4.6C16.6737 2.90294 16.6737 2.05442 16.1465 1.52721C15.6193 1 14.7707 1 13.0737 1H8.00723C6.31017 1 5.46164 1 4.93443 1.52721C4.40723 2.05442 4.40723 2.90294 4.40723 4.6V5.08882"
        stroke={fillColor}
        strokewidth="2"
      />
    </svg>
  );
};

export const AlarmClock = ({ fillColor }) => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="16.5"
        cy="17.875"
        rx="9.625"
        ry="9.625"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M6.875 6.875L4.125 9.625"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M26.125 6.875L28.875 9.625"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.375 15.125L16.3093 17.7479C16.4172 17.8198 16.5622 17.7973 16.6432 17.696L19.25 14.4375"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NewMeeting = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="39"
      viewBox="0 0 30 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.643 5.29224C24.2531 5.29224 25.5582 5.29224 26.4956 5.91864C26.9015 6.18982 27.2499 6.53828 27.5211 6.94413C28.1475 7.88161 28.1475 9.18666 28.1475 11.7968V29.4519C28.1475 32.9562 28.1475 34.7084 27.0589 35.797C25.9702 36.8857 24.2181 36.8857 20.7138 36.8857H9.56315C6.05884 36.8857 4.30669 36.8857 3.21804 35.797C2.12939 34.7084 2.12939 32.9562 2.12939 29.4519V11.7968C2.12939 9.18666 2.12939 7.88161 2.7558 6.94413C3.02698 6.53828 3.37544 6.18982 3.78128 5.91864C4.71877 5.29224 6.02382 5.29224 8.63393 5.29224"
        stroke={fillColor}
        strokeWidth="3"
      />
      <path
        d="M9.56348 5.29207C9.56348 3.2393 11.2276 1.5752 13.2804 1.5752H16.9972C19.05 1.5752 20.7141 3.2393 20.7141 5.29207C20.7141 7.34484 19.05 9.00895 16.9972 9.00895H13.2804C11.2276 9.00895 9.56348 7.34484 9.56348 5.29207Z"
        stroke={fillColor}
        strokeWidth="3"
      />
      <path
        d="M9.56348 18.3013L20.7141 18.3013"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M9.56348 25.7351L16.9972 25.7351"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Notes = ({ fillColor }) => {
  return (
    <svg
      width="46"
      height="45"
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.89551"
        y="7.43384"
        width="26.0181"
        height="31.5934"
        rx="2"
        stroke={fillColor}
        strokewidth="3"
      />
      <path
        d="M17.3296 16.7258H28.4802"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M17.3296 24.1597H28.4802"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M17.3296 31.5935H24.7633"
        stroke={fillColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ArchiveIcon = ({ fillColor }) => {
  return (
    <svg
      width="46"
      height="45"
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.271 11.4338C8.271 9.54822 8.271 8.60541 8.85678 8.01962C9.44257 7.43384 10.3854 7.43384 12.271 7.43384H34.006C35.8916 7.43384 36.8344 7.43384 37.4202 8.01962C38.006 8.60541 38.006 9.54822 38.006 11.4338V33.1688C38.006 35.0545 38.006 35.9973 37.4202 36.5831C36.8344 37.1688 35.8916 37.1688 34.006 37.1688H12.271C10.3854 37.1688 9.44257 37.1688 8.85678 36.5831C8.271 35.9973 8.271 35.0545 8.271 33.1688V11.4338Z"
        stroke={fillColor}
        strokeWidth="3"
      />
      <path
        d="M8.271 19.3276V20.1596C8.271 22.0452 8.271 22.988 8.85678 23.5738C9.44257 24.1596 10.3854 24.1596 12.271 24.1596H15.1008C15.7913 24.1596 16.1365 24.1596 16.3974 24.3461C16.6583 24.5326 16.7699 24.8593 16.9933 25.5126L17.7201 27.6385C17.9435 28.2918 18.0551 28.6185 18.316 28.805C18.5769 28.9915 18.9221 28.9915 19.6126 28.9915H26.6644C27.3549 28.9915 27.7001 28.9915 27.961 28.805C28.2219 28.6185 28.3335 28.2918 28.5569 27.6385L29.2837 25.5126C29.5071 24.8593 29.6187 24.5326 29.8796 24.3461C30.1405 24.1596 30.4857 24.1596 31.1762 24.1596H34.006C35.8916 24.1596 36.8344 24.1596 37.4202 23.5738C38.006 22.988 38.006 22.0452 38.006 20.1596V19.3276"
        stroke={fillColor}
        strokeWidth="3"
      />
    </svg>
  );
};

export const MobileIcon = ({ fillColor }) => {
  return (
    <svg
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <mask id="path-1-inside-1_148_1426" fill={fillColor}>
          <path d="M6.61024 7.69006C6.61024 6.37024 7.68017 5.30031 8.99999 5.30031C10.3198 5.30031 11.3897 6.37024 11.3897 7.69006C11.3897 9.00988 10.3198 10.0798 8.99999 10.0798C7.68017 10.0798 6.61024 9.00988 6.61024 7.69006Z" />
          <path d="M7.80512 11.8721C5.82538 11.8721 4.22049 13.477 4.22049 15.4567C4.22049 16.1167 4.75546 16.6516 5.41537 16.6516H12.5846C13.2445 16.6516 13.7795 16.1167 13.7795 15.4567C13.7795 13.477 12.1746 11.8721 10.1949 11.8721H7.80512Z" />
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M3.67507 0.380635C7.20688 -0.126878 10.7931 -0.126878 14.3249 0.380635C16.076 0.63226 17.4251 2.05343 17.5854 3.81522L17.7371 5.48294C18.0876 9.33615 18.0876 13.2132 17.7371 17.0664L17.5854 18.7341C17.4251 20.4959 16.076 21.9171 14.3249 22.1687C10.7931 22.6762 7.20688 22.6762 3.67507 22.1687C1.92399 21.9171 0.574866 20.4959 0.414599 18.7341L0.262889 17.0664C-0.0876295 13.2132 -0.0876298 9.33615 0.262889 5.48295L0.414599 3.81522C0.574865 2.05343 1.92399 0.63226 3.67507 0.380635ZM14.07 2.15472C10.7073 1.67151 7.29273 1.67151 3.93 2.15472C3.00063 2.28827 2.2846 3.04254 2.19954 3.9776L2.04783 5.64532C1.70714 9.3905 1.70714 13.1589 2.04783 16.904L2.19954 18.5718C2.2846 19.5068 3.00063 20.2611 3.93 20.3946C7.29273 20.8779 10.7073 20.8779 14.07 20.3946C14.9994 20.2611 15.7154 19.5068 15.8005 18.5718L15.9522 16.904C16.2929 13.1589 16.2929 9.39049 15.9522 5.64532L15.8005 3.97759C15.7154 3.04254 14.9994 2.28827 14.07 2.15472Z"
          />
        </mask>
        <path
          d="M6.61024 7.69006C6.61024 6.37024 7.68017 5.30031 8.99999 5.30031C10.3198 5.30031 11.3897 6.37024 11.3897 7.69006C11.3897 9.00988 10.3198 10.0798 8.99999 10.0798C7.68017 10.0798 6.61024 9.00988 6.61024 7.69006Z"
          fill={fillColor}
        />
        <path
          d="M7.80512 11.8721C5.82538 11.8721 4.22049 13.477 4.22049 15.4567C4.22049 16.1167 4.75546 16.6516 5.41537 16.6516H12.5846C13.2445 16.6516 13.7795 16.1167 13.7795 15.4567C13.7795 13.477 12.1746 11.8721 10.1949 11.8721H7.80512Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clip-rule="evenodd"
          d="M3.67507 0.380635C7.20688 -0.126878 10.7931 -0.126878 14.3249 0.380635C16.076 0.63226 17.4251 2.05343 17.5854 3.81522L17.7371 5.48294C18.0876 9.33615 18.0876 13.2132 17.7371 17.0664L17.5854 18.7341C17.4251 20.4959 16.076 21.9171 14.3249 22.1687C10.7931 22.6762 7.20688 22.6762 3.67507 22.1687C1.92399 21.9171 0.574866 20.4959 0.414599 18.7341L0.262889 17.0664C-0.0876295 13.2132 -0.0876298 9.33615 0.262889 5.48295L0.414599 3.81522C0.574865 2.05343 1.92399 0.63226 3.67507 0.380635ZM14.07 2.15472C10.7073 1.67151 7.29273 1.67151 3.93 2.15472C3.00063 2.28827 2.2846 3.04254 2.19954 3.9776L2.04783 5.64532C1.70714 9.3905 1.70714 13.1589 2.04783 16.904L2.19954 18.5718C2.2846 19.5068 3.00063 20.2611 3.93 20.3946C7.29273 20.8779 10.7073 20.8779 14.07 20.3946C14.9994 20.2611 15.7154 19.5068 15.8005 18.5718L15.9522 16.904C16.2929 13.1589 16.2929 9.39049 15.9522 5.64532L15.8005 3.97759C15.7154 3.04254 14.9994 2.28827 14.07 2.15472Z"
          fill={fillColor}
        />
        <path
          d="M6.61024 7.69006C6.61024 6.37024 7.68017 5.30031 8.99999 5.30031C10.3198 5.30031 11.3897 6.37024 11.3897 7.69006C11.3897 9.00988 10.3198 10.0798 8.99999 10.0798C7.68017 10.0798 6.61024 9.00988 6.61024 7.69006Z"
          stroke={fillColor}
          strokeWidth="4"
          mask="url(#path-1-inside-1_148_1426)"
        />
        <path
          d="M7.80512 11.8721C5.82538 11.8721 4.22049 13.477 4.22049 15.4567C4.22049 16.1167 4.75546 16.6516 5.41537 16.6516H12.5846C13.2445 16.6516 13.7795 16.1167 13.7795 15.4567C13.7795 13.477 12.1746 11.8721 10.1949 11.8721H7.80512Z"
          stroke={fillColor}
          strokeWidth="4"
          mask="url(#path-1-inside-1_148_1426)"
        />
        <path
          fillRule="evenodd"
          clip-rule="evenodd"
          d="M3.67507 0.380635C7.20688 -0.126878 10.7931 -0.126878 14.3249 0.380635C16.076 0.63226 17.4251 2.05343 17.5854 3.81522L17.7371 5.48294C18.0876 9.33615 18.0876 13.2132 17.7371 17.0664L17.5854 18.7341C17.4251 20.4959 16.076 21.9171 14.3249 22.1687C10.7931 22.6762 7.20688 22.6762 3.67507 22.1687C1.92399 21.9171 0.574866 20.4959 0.414599 18.7341L0.262889 17.0664C-0.0876295 13.2132 -0.0876298 9.33615 0.262889 5.48295L0.414599 3.81522C0.574865 2.05343 1.92399 0.63226 3.67507 0.380635ZM14.07 2.15472C10.7073 1.67151 7.29273 1.67151 3.93 2.15472C3.00063 2.28827 2.2846 3.04254 2.19954 3.9776L2.04783 5.64532C1.70714 9.3905 1.70714 13.1589 2.04783 16.904L2.19954 18.5718C2.2846 19.5068 3.00063 20.2611 3.93 20.3946C7.29273 20.8779 10.7073 20.8779 14.07 20.3946C14.9994 20.2611 15.7154 19.5068 15.8005 18.5718L15.9522 16.904C16.2929 13.1589 16.2929 9.39049 15.9522 5.64532L15.8005 3.97759C15.7154 3.04254 14.9994 2.28827 14.07 2.15472Z"
          stroke={fillColor}
          strokeWidth="4"
          mask="url(#path-1-inside-1_148_1426)"
        />
      </g>
    </svg>
  );
};

export const Notification = ({ fillColor }) => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8333 47.5V45.1667C19.8333 43.929 19.3417 42.742 18.4665 41.8668C17.5913 40.9917 16.4043 40.5 15.1667 40.5H5.83332C4.59565 40.5 3.40866 40.9917 2.53349 41.8668C1.65832 42.742 1.16666 43.929 1.16666 45.1667V47.5"
        stroke="#0B6AAB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 35.8333C13.0773 35.8333 15.1667 33.744 15.1667 31.1667C15.1667 28.5893 13.0773 26.5 10.5 26.5C7.92268 26.5 5.83334 28.5893 5.83334 31.1667C5.83334 33.744 7.92268 35.8333 10.5 35.8333Z"
        stroke="#0B6AAB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8333 47.5V45.1667C26.8325 44.1327 26.4884 43.1282 25.8549 42.311C25.2214 41.4938 24.3345 40.9102 23.3333 40.6517"
        stroke="#0B6AAB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6667 26.6517C19.6705 26.9087 20.5602 27.4925 21.1956 28.311C21.831 29.1296 22.1758 30.1363 22.1758 31.1725C22.1758 32.2087 21.831 33.2154 21.1956 34.034C20.5602 34.8525 19.6705 35.4363 18.6667 35.6933"
        stroke="#0B6AAB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="25" width="22" height="22" fill={fillColor} />
      <path
        d="M34.19 14.13C34.302 15.628 35.338 17.014 37.508 17.014C40.21 17.014 40.98 15.138 40.98 11.666C40.98 8.432 40.126 6.556 37.354 6.556C35.198 6.556 33.91 7.9 33.91 9.944C33.91 12.1 35.324 13.206 37.088 13.206C37.984 13.206 38.81 12.856 39.244 12.254C39.244 14.55 38.74 15.404 37.592 15.404C36.682 15.404 36.164 14.942 36.01 14.13H34.19ZM37.494 11.61C36.304 11.61 35.786 10.854 35.786 9.93C35.786 8.908 36.402 8.222 37.424 8.222C38.418 8.222 39.062 8.838 39.062 9.958C39.062 10.952 38.474 11.61 37.494 11.61Z"
        fill="white"
      />
    </svg>
  );
};

export const Filter = ({ fillColor }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.62393 18.9203L7.94016 19.869H7.94016L7.62393 18.9203ZM13.3739 17.0036L13.0577 16.0549H13.0577L13.3739 17.0036ZM19.0479 4.80754L19.755 5.51465L19.0479 4.80754ZM6.67293 9.84675L7.38003 9.13965L6.67293 9.84675ZM2.34082 2.13965H18.3408V0.139648H2.34082V2.13965ZM2.34082 4.10043V2.13965H0.34082V4.10043H2.34082ZM7.38003 9.13965L2.34082 4.10043L0.926607 5.51465L5.96582 10.5539L7.38003 9.13965ZM5.96582 10.5539V18.4459H7.96582V10.5539H5.96582ZM5.96582 18.4459C5.96582 19.4698 6.96887 20.1927 7.94016 19.869L7.30771 17.9716C7.63147 17.8637 7.96582 18.1047 7.96582 18.4459H5.96582ZM7.94016 19.869L13.6902 17.9523L13.0577 16.0549L7.30771 17.9716L7.94016 19.869ZM13.6902 17.9523C14.3027 17.7481 14.7158 17.1749 14.7158 16.5293H12.7158C12.7158 16.3141 12.8535 16.123 13.0577 16.0549L13.6902 17.9523ZM14.7158 16.5293V10.5539H12.7158V16.5293H14.7158ZM18.3408 4.10043L13.3016 9.13965L14.7158 10.5539L19.755 5.51465L18.3408 4.10043ZM18.3408 2.13965V4.10043H20.3408V2.13965H18.3408ZM19.755 5.51465C20.1301 5.13958 20.3408 4.63087 20.3408 4.10043H18.3408L19.755 5.51465ZM14.7158 10.5539V10.5539L13.3016 9.13965C12.9265 9.51472 12.7158 10.0234 12.7158 10.5539H14.7158ZM5.96582 10.5539H7.96582C7.96582 10.0234 7.75511 9.51472 7.38003 9.13965L5.96582 10.5539ZM0.34082 4.10043C0.34082 4.63087 0.551534 5.13958 0.926607 5.51465L2.34082 4.10043H2.34082H0.34082ZM18.3408 2.13965V2.13965H20.3408C20.3408 1.03508 19.4454 0.139648 18.3408 0.139648V2.13965ZM2.34082 0.139648C1.23625 0.139648 0.34082 1.03508 0.34082 2.13965H2.34082V2.13965V0.139648Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Time = ({ fillColor }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11.3816"
        cy="11.7807"
        r="10.2009"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M16.5569 11.7805H11.6313C11.4933 11.7805 11.3813 11.6686 11.3813 11.5305V7.75513"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Calender = ({ fillColor }) => {
  return (
    <svg
      width="23"
      height="26"
      viewBox="0 0 23 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5459"
        y="4.52441"
        width="19.6709"
        height="19.6709"
        rx="2"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M16.2988 1.83594L16.2988 7.21252C16.2988 8.15533 16.2988 8.62673 16.0059 8.91962C15.713 9.21252 15.2416 9.21252 14.2988 9.21252L8.46338 9.21252C7.52057 9.21252 7.04917 9.21252 6.75627 8.91963C6.46338 8.62674 6.46338 8.15533 6.46338 7.21252L6.46338 1.83594"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.69287 15.5892L15.0695 15.5892"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UpArrow = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="13"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95782 3L6.8981 1.93841L7.95782 0.880546L9.01755 1.93841L7.95782 3ZM0.940275 7.88574L6.8981 1.93841L9.01755 4.06159L3.05972 10.0089L0.940275 7.88574ZM9.01755 1.93841L14.9754 7.88574L12.8559 10.0089L6.8981 4.06159L9.01755 1.93841Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Print = ({ fillColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13.5H18.5C19.4428 13.5 19.9142 13.5 20.2071 13.2071C20.5 12.9142 20.5 12.4428 20.5 11.5V10.5C20.5 8.61438 20.5 7.67157 19.9142 7.08579C19.3284 6.5 18.3856 6.5 16.5 6.5H7.5C5.61438 6.5 4.67157 6.5 4.08579 7.08579C3.5 7.67157 3.5 8.61438 3.5 10.5V12.5C3.5 12.9714 3.5 13.2071 3.64645 13.3536C3.79289 13.5 4.0286 13.5 4.5 13.5H6"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M6.5 19.8063L6.5 11.5C6.5 10.5572 6.5 10.0858 6.79289 9.79289C7.08579 9.5 7.55719 9.5 8.5 9.5L15.5 9.5C16.4428 9.5 16.9142 9.5 17.2071 9.79289C17.5 10.0858 17.5 10.5572 17.5 11.5L17.5 19.8063C17.5 20.1228 17.5 20.2811 17.3962 20.356C17.2924 20.4308 17.1422 20.3807 16.8419 20.2806L14.6738 19.5579C14.5878 19.5293 14.5448 19.5149 14.5005 19.5162C14.4561 19.5175 14.4141 19.5344 14.3299 19.568L12.1857 20.4257C12.094 20.4624 12.0481 20.4807 12 20.4807C11.9519 20.4807 11.906 20.4624 11.8143 20.4257L9.67005 19.568C9.58592 19.5344 9.54385 19.5175 9.49952 19.5162C9.45519 19.5149 9.41221 19.5293 9.32625 19.5579L7.15811 20.2806C6.8578 20.3807 6.70764 20.4308 6.60382 20.356C6.5 20.2811 6.5 20.1228 6.5 19.8063Z"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M9.5 13.5L13.5 13.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.5 16.5L14.5 16.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.5 6.5V6.1C17.5 4.40294 17.5 3.55442 16.9728 3.02721C16.4456 2.5 15.5971 2.5 13.9 2.5H10.1C8.40294 2.5 7.55442 2.5 7.02721 3.02721C6.5 3.55442 6.5 4.40294 6.5 6.1V6.5"
        stroke={fillColor}
        strokeWidth="2"
      />
    </svg>
  );
};
export const UpDirection = ({ fillColor }) => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.7085 2.20105L9.36069 1.443L8.7085 0.881872L8.0563 1.443L8.7085 2.20105ZM7.7085 18.3329C7.7085 18.8852 8.15621 19.3329 8.7085 19.3329C9.26078 19.3329 9.7085 18.8852 9.7085 18.3329L7.7085 18.3329ZM16.8607 7.89575L9.36069 1.443L8.0563 2.9591L15.5563 9.41184L16.8607 7.89575ZM8.0563 1.443L0.556297 7.89575L1.86069 9.41184L9.36069 2.9591L8.0563 1.443ZM7.7085 2.20105L7.7085 18.3329L9.7085 18.3329L9.7085 2.20105L7.7085 2.20105Z"
        fill={fillColor}
      />
    </svg>
  );
};
//   );
// };

export const Upload = ({ fillColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
        fill={fillColor}
      />
      <path
        d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
        stroke={fillColor}
        strokeWidth="2"
      />
    </svg>
  );
};

export const Profile = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8296 17.255C14.5448 16.369 13.917 15.5861 13.0438 15.0278C12.1706 14.4694 11.1007 14.1667 10 14.1667C8.89933 14.1667 7.82942 14.4694 6.95619 15.0278C6.08297 15.5861 5.45525 16.369 5.17037 17.255"
        stroke={fillColor}
        strokeWidth="2"
      />
      <ellipse
        cx="10"
        cy="8.33325"
        rx="2.5"
        ry="2.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="2.6665"
        y="2.66675"
        width="14.6667"
        height="14.6667"
        rx="3"
        stroke={fillColor}
        strokeWidth="2"
      />
    </svg>
  );
};

export const Balance = ({ fillColor }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 8.83333H17.5H16.5ZM15.6332 2.94713L16.622 3.09617L15.6332 2.94713ZM13.1138 5.46649L13.2628 6.45532L13.1138 5.46649ZM11.634 11.6667L12.5 11.1667L11.634 11.6667ZM12 12.0327L11.5 12.8987L12 12.0327ZM11.634 9.33333L10.7679 8.83333L11.634 9.33333ZM12 8.96731L11.5 8.10128L12 8.96731ZM16.2071 5.79289L16.9142 5.08579L16.2071 5.79289ZM14.5 15.5V16.5V15.5ZM16.2071 15.2071L16.9142 15.9142L16.2071 15.2071ZM5.50001 15.5V16.5V15.5ZM2.08579 14.9142L1.37868 15.6213L2.08579 14.9142ZM15.2412 1.33892L15.0921 2.32775L15.2412 1.33892ZM15.6611 1.75881L16.6499 1.60977L15.6611 1.75881ZM3.58334 2.33333L15.0714 2.33333V0.333334L3.58334 0.333334V2.33333ZM5.50001 16.5L14.5 16.5V14.5L5.50001 14.5V16.5ZM0.500006 3.41667L0.500006 11.5L2.50001 11.5L2.50001 3.41667H0.500006ZM14.5 4.5L3.58334 4.5V6.5L14.5 6.5V4.5ZM15.5 12.1667V13.5L17.5 13.5L17.5 12.1667H15.5ZM15.5 7.5V8.83333H17.5L17.5 7.5H15.5ZM13.1667 13.1667H16.5V11.1667H13.1667V13.1667ZM15.5 8.83333L15.5 12.1667H17.5L17.5 8.83333H15.5ZM16.5 7.83333L13.1667 7.83333L13.1667 9.83333H16.5V7.83333ZM12.0952 4.5H11.5V6.5H12.0952V4.5ZM14.6667 1.92857C14.6667 2.49578 14.6639 2.66856 14.6443 2.79808L16.622 3.09617C16.6695 2.78108 16.6667 2.42303 16.6667 1.92857H14.6667ZM12.0952 6.5C12.5897 6.5 12.9477 6.50282 13.2628 6.45532L12.9648 4.47766C12.8352 4.49718 12.6624 4.5 12.0952 4.5V6.5ZM14.6443 2.79808C14.5135 3.66578 13.8324 4.34688 12.9648 4.47766L13.2628 6.45532C14.9982 6.19376 16.3604 4.83155 16.622 3.09617L14.6443 2.79808ZM10.5 10.5C10.5 10.7931 10.499 11.0798 10.5208 11.3202C10.5439 11.5744 10.5984 11.8731 10.7679 12.1667L12.5 11.1667C12.5355 11.2282 12.5231 11.2551 12.5127 11.1397C12.501 11.0105 12.5 10.8299 12.5 10.5H10.5ZM13.1667 11.1667C12.8367 11.1667 12.6561 11.1657 12.527 11.154C12.4115 11.1435 12.4385 11.1311 12.5 11.1667L11.5 12.8987C11.7936 13.0682 12.0923 13.1228 12.3464 13.1458C12.5868 13.1676 12.8735 13.1667 13.1667 13.1667V11.1667ZM10.7679 12.1667C10.9435 12.4707 11.196 12.7232 11.5 12.8987L12.5 11.1667L10.7679 12.1667ZM12.5 10.5C12.5 10.1701 12.501 9.98946 12.5127 9.8603C12.5231 9.74488 12.5355 9.77179 12.5 9.83333L10.7679 8.83333C10.5984 9.12692 10.5439 9.42563 10.5208 9.67977C10.499 9.92015 10.5 10.2069 10.5 10.5H12.5ZM13.1667 7.83333C12.8735 7.83333 12.5868 7.83238 12.3464 7.85416C12.0923 7.8772 11.7936 7.93178 11.5 8.10128L12.5 9.83333C12.4385 9.86886 12.4115 9.85646 12.527 9.846C12.6561 9.83429 12.8367 9.83333 13.1667 9.83333L13.1667 7.83333ZM12.5 9.83333H12.5L11.5 8.10128C11.196 8.27682 10.9435 8.52929 10.7679 8.83333L12.5 9.83333ZM14.5 6.5C14.9997 6.5 15.2738 6.50212 15.464 6.52769C15.6254 6.5494 15.5703 6.57032 15.5 6.5L16.9142 5.08579C16.551 4.72257 16.1137 4.59705 15.7305 4.54553C15.3761 4.49788 14.9431 4.5 14.5 4.5V6.5ZM17.5 7.5C17.5 7.05687 17.5021 6.62392 17.4545 6.26948C17.403 5.88628 17.2774 5.449 16.9142 5.08579L15.5 6.5C15.4297 6.42968 15.4506 6.37455 15.4723 6.53598C15.4979 6.72617 15.5 7.00033 15.5 7.5H17.5ZM14.5 16.5C14.9431 16.5 15.3761 16.5021 15.7305 16.4545C16.1137 16.403 16.551 16.2774 16.9142 15.9142L15.5 14.5C15.5703 14.4297 15.6254 14.4506 15.464 14.4723C15.2738 14.4979 14.9997 14.5 14.5 14.5V16.5ZM15.5 13.5C15.5 13.9997 15.4979 14.2738 15.4723 14.464C15.4506 14.6254 15.4297 14.5703 15.5 14.5L16.9142 15.9142C17.2774 15.551 17.403 15.1137 17.4545 14.7305C17.5021 14.3761 17.5 13.9431 17.5 13.5L15.5 13.5ZM5.50001 14.5C4.52893 14.5 3.90122 14.4979 3.43871 14.4357C3.00497 14.3774 2.86902 14.2832 2.7929 14.2071L1.37868 15.6213C1.88835 16.131 2.5167 16.3297 3.17221 16.4179C3.79896 16.5021 4.58547 16.5 5.50001 16.5V14.5ZM0.500006 11.5C0.500006 12.4145 0.497883 13.201 0.582147 13.8278C0.670279 14.4833 0.869023 15.1117 1.37868 15.6213L2.7929 14.2071C2.71677 14.131 2.62263 13.995 2.56431 13.5613C2.50213 13.0988 2.50001 12.4711 2.50001 11.5L0.500006 11.5ZM0.500006 3.41667C0.500006 5.11954 1.88046 6.5 3.58334 6.5V4.5C2.98503 4.5 2.50001 4.01498 2.50001 3.41667H0.500006ZM15.0714 2.33333C15.0943 2.33333 15.1109 2.33334 15.125 2.33341C15.1391 2.33348 15.1462 2.3336 15.1495 2.33369C15.1527 2.33378 15.148 2.33372 15.1385 2.33303C15.1284 2.33228 15.1123 2.33078 15.0921 2.32775L15.3902 0.350087C15.2604 0.330518 15.1235 0.333334 15.0714 0.333334V2.33333ZM16.6667 1.92857C16.6667 1.87647 16.6695 1.7396 16.6499 1.60977L14.6723 1.90786C14.6692 1.88773 14.6677 1.87165 14.667 1.86146C14.6663 1.85196 14.6662 1.84729 14.6663 1.8505C14.6664 1.85383 14.6665 1.86094 14.6666 1.87502C14.6667 1.88912 14.6667 1.90572 14.6667 1.92857H16.6667ZM15.0921 2.32775C14.8752 2.29505 14.7049 2.12478 14.6723 1.90786L16.6499 1.60977C16.5518 0.959002 16.041 0.448174 15.3902 0.350087L15.0921 2.32775ZM2.50001 3.41667C2.50001 2.81836 2.98503 2.33333 3.58334 2.33333V0.333334C1.88046 0.333334 0.500006 1.71379 0.500006 3.41667H2.50001Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Logout = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.82477 17.7544L6.3204 18.6179L6.82477 17.7544ZM6.26653 17.2702L7.05001 16.6488L6.26653 17.2702ZM16.7665 16.0305L17.522 16.6857L16.7665 16.0305ZM16.7665 3.9697L17.522 3.31449L16.7665 3.9697ZM9.9257 3.2615L12.2073 3.58744L12.4901 1.60754L10.2085 1.2816L9.9257 3.2615ZM16.5002 8.53719V11.463H18.5002V8.53719H16.5002ZM12.2073 16.4127L9.76244 16.762L10.0453 18.7419L12.4901 18.3926L12.2073 16.4127ZM9.76244 16.762C8.9136 16.8832 8.35915 16.961 7.9398 16.9739C7.53676 16.9863 7.39766 16.9309 7.32913 16.8909L6.3204 18.6179C6.8536 18.9293 7.42825 18.9906 8.00144 18.973C8.55831 18.9558 9.24255 18.8566 10.0453 18.7419L9.76244 16.762ZM4.8335 14.2217C4.8335 15.0326 4.83203 15.724 4.89379 16.2777C4.95735 16.8476 5.09933 17.4078 5.48304 17.8916L7.05001 16.6488C7.0007 16.5866 6.92616 16.4568 6.88146 16.056C6.83496 15.6391 6.8335 15.0792 6.8335 14.2217H4.8335ZM7.32913 16.8909C7.22186 16.8282 7.12721 16.7461 7.05001 16.6488L5.48304 17.8916C5.71463 18.1836 5.9986 18.4299 6.3204 18.6179L7.32913 16.8909ZM16.5002 11.463C16.5002 12.7296 16.4983 13.5857 16.4163 14.2346C16.3379 14.8555 16.1991 15.1585 16.0111 15.3753L17.522 16.6857C18.0676 16.0565 18.2956 15.3163 18.4006 14.4852C18.502 13.6821 18.5002 12.6775 18.5002 11.463H16.5002ZM12.4901 18.3926C13.6924 18.2209 14.6872 18.0806 15.4679 17.8666C16.2758 17.6452 16.9763 17.3148 17.522 16.6857L16.0111 15.3753C15.8231 15.592 15.5427 15.7723 14.9392 15.9378C14.3084 16.1107 13.4611 16.2336 12.2073 16.4127L12.4901 18.3926ZM12.2073 3.58744C13.4611 3.76656 14.3084 3.88949 14.9392 4.06238C15.5427 4.22783 15.8231 4.40814 16.0111 4.6249L17.522 3.31449C16.9763 2.68536 16.2758 2.355 15.4679 2.13354C14.6872 1.91952 13.6924 1.77929 12.4901 1.60754L12.2073 3.58744ZM18.5002 8.53719C18.5002 7.32271 18.502 6.31809 18.4006 5.51493C18.2956 4.68383 18.0676 3.94363 17.522 3.31449L16.0111 4.6249C16.1991 4.84165 16.3379 5.14467 16.4163 5.76557C16.4983 6.41442 16.5002 7.2706 16.5002 8.53719H18.5002ZM10.2085 1.2816C9.33071 1.1562 8.58263 1.04758 7.97663 1.03477C7.35095 1.02154 6.72701 1.10335 6.16469 1.47976L7.27723 3.14176C7.3517 3.09191 7.49772 3.02509 7.93437 3.03432C8.39068 3.04397 8.99729 3.12887 9.9257 3.2615L10.2085 1.2816ZM6.8335 5.94336C6.8335 5.00552 6.83523 4.393 6.89022 3.93991C6.94283 3.50635 7.02963 3.37124 7.08951 3.30457L5.60155 1.96817C5.1494 2.4716 4.98018 3.0777 4.90478 3.69896C4.83176 4.30069 4.8335 5.05661 4.8335 5.94336H6.8335ZM6.16469 1.47976C5.9574 1.61852 5.76823 1.78259 5.60155 1.96817L7.08951 3.30457C7.14507 3.24271 7.20813 3.18802 7.27723 3.14176L6.16469 1.47976Z"
        fill={fillColor}
      />
      <path
        d="M13.3335 9.99992L14.1144 9.37522L14.6141 9.99992L14.1144 10.6246L13.3335 9.99992ZM3.3335 10.9999C2.78121 10.9999 2.3335 10.5522 2.3335 9.99992C2.3335 9.44763 2.78121 8.99992 3.3335 8.99992V10.9999ZM10.781 5.20856L14.1144 9.37522L12.5526 10.6246L9.21929 6.45795L10.781 5.20856ZM14.1144 10.6246L10.781 14.7913L9.21929 13.5419L12.5526 9.37522L14.1144 10.6246ZM13.3335 10.9999H3.3335V8.99992H13.3335V10.9999Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CRM = ({ fillColor }) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 5.0625H15.625V12C15.625 12.9428 15.625 13.4142 15.3321 13.7071C15.0392 14 14.5678 14 13.625 14H10.75V5.0625Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1 5.0625H5.875V14H3C2.05719 14 1.58579 14 1.29289 13.7071C1 13.4142 1 12.9428 1 12V5.0625Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="5.875"
        y="5.0625"
        width="4.875"
        height="8.9375"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1 3C1 2.05719 1 1.58579 1.29289 1.29289C1.58579 1 2.05719 1 3 1H13.625C14.5678 1 15.0392 1 15.3321 1.29289C15.625 1.58579 15.625 2.05719 15.625 3V5.0625H1V3Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Offshore = ({ fillColor }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.45 3.3999L13.5103 4.15164C13.1557 4.43534 12.7151 4.5899 12.2609 4.5899H10.0455C9.55626 4.5899 9.11111 4.87286 8.90344 5.31589V5.31589C8.66459 5.82543 8.79218 6.43156 9.21616 6.80158L10.5565 7.97136C11.8319 9.08441 12.4863 10.7482 12.3109 12.4318V12.4318C12.2497 13.0193 12.1138 13.5965 11.9064 14.1495L11.475 15.2999"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M0.424805 7.225L3.04318 6.7886C4.25946 6.58589 5.31391 7.64035 5.1112 8.85662L5.0192 9.40863C4.81449 10.6369 5.43479 11.855 6.54852 12.4119V12.4119C7.44031 12.8578 7.90275 13.8632 7.66093 14.8305L7.22481 16.575"
        stroke={fillColor}
        strokeWidth="2"
      />
      <circle cx="8.5" cy="8.5" r="7.5" stroke={fillColor} strokeWidth="2" />
    </svg>
  );
};

export const DateIcon = ({ fillColor, handleClick, height, width }) => {
  return (
    <svg
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => handleClick()}
    >
      <rect
        x="3"
        y="6"
        width="18"
        height="15"
        rx="2"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M4 11H20"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 16H15"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8 3L8 7"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 3L16 7"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const Hambergurmenu = ({ fillColor, handleClick }) => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10" y="14" width="26" height="3" rx="1.5" fill={fillColor} />
      <rect x="17" y="22" width="26" height="3" rx="1.5" fill={fillColor} />
      <rect x="10" y="30" width="26" height="3" rx="1.5" fill={fillColor} />
    </svg>
    // "#3E4954"
  );
};

export const Check = () => {
  return (
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>background</title>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <title>Layer 1</title>
        <path
          id="svg_1"
          fill="#ffffff"
          d="m16,0c-8.836,0 -16,7.164 -16,16s7.164,16 16,16s16,-7.164 16,-16s-7.164,-16 -16,-16zm-2.48,23.383l-7.362,-7.363l2.828,-2.828l4.533,4.535l9.617,-9.617l2.828,2.828l-12.444,12.445z"
        />
      </g>
    </svg>
  );
};
export const Error = () => {
  return (
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>background</title>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <title>Layer 1</title>
        <circle fill="#ffffff" r="16" id="BG" cy="16" cx="16" />
        <path
          fill="#d72828"
          id="Exclamatory_x5F_Sign"
          d="m14.5,25l3,0l0,-3l-3,0l0,3zm0,-19l0,13l3,0l0,-13l-3,0z"
        />
      </g>
    </svg>
  );
};

export const Info = () => {
  return (
    <svg width="85" height="85" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>background</title>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <title>Layer 1</title>
        <path
          fill="#ffffff"
          id="svg_1"
          d="m42.5,0.003c-23.472,0 -42.5,19.028 -42.5,42.5s19.028,42.5 42.5,42.5s42.5,-19.027 42.5,-42.5s-19.028,-42.5 -42.5,-42.5zm-0.212,66.267c0,0 -1.972,1.311 -3.32,1.305c-0.12,0.055 -0.191,0.087 -0.191,0.087l0.003,-0.087c-0.283,-0.013 -0.568,-0.053 -0.855,-0.125l-0.426,-0.105c-2.354,-0.584 -3.6,-2.918 -3.014,-5.271l3.277,-13.211l1.479,-5.967c1.376,-5.54 -4.363,1.178 -5.54,-1.374c-0.777,-1.687 4.464,-5.227 8.293,-7.896c0,0 1.97,-1.309 3.319,-1.304c0.121,-0.056 0.192,-0.087 0.192,-0.087l-0.005,0.087c0.285,0.013 0.57,0.053 0.857,0.124l0.426,0.106c2.354,0.584 3.788,2.965 3.204,5.318l-3.276,13.212l-1.482,5.967c-1.374,5.54 4.27,-1.204 5.446,1.351c0.777,1.685 -4.559,5.201 -8.387,7.87zm8.306,-41.294c-0.818,3.295 -4.152,5.304 -7.446,4.486c-3.296,-0.818 -5.305,-4.151 -4.487,-7.447c0.818,-3.296 4.152,-5.304 7.446,-4.486c3.296,0.817 5.304,4.151 4.487,7.447z"
        />
      </g>
    </svg>
  );
};

export const Warning = () => {
  return (
    <svg width="1792" height="1792" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>background</title>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <title>Layer 1</title>
        <path
          fill="#ffffff"
          id="svg_1"
          d="m1024,1375l0,-190q0,-14 -9.5,-23.5t-22.5,-9.5l-192,0q-13,0 -22.5,9.5t-9.5,23.5l0,190q0,14 9.5,23.5t22.5,9.5l192,0q13,0 22.5,-9.5t9.5,-23.5zm-2,-374l18,-459q0,-12 -10,-19q-13,-11 -24,-11l-220,0q-11,0 -24,11q-10,7 -10,21l17,457q0,10 10,16.5t24,6.5l185,0q14,0 23.5,-6.5t10.5,-16.5zm-14,-934l768,1408q35,63 -2,126q-17,29 -46.5,46t-63.5,17l-1536,0q-34,0 -63.5,-17t-46.5,-46q-37,-63 -2,-126l768,-1408q17,-31 47,-49t65,-18t65,18t47,49z"
        />
      </g>
    </svg>
  );
};

export const MoreIcon = ({ fillColor }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81276 9.66458C10.2233 9.66458 10.5562 9.33174 10.5562 8.92116C10.5562 8.51058 10.2233 8.17773 9.81276 8.17773C9.40218 8.17773 9.06934 8.51058 9.06934 8.92116C9.06934 9.33174 9.40218 9.66458 9.81276 9.66458Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81276 4.46047C10.2233 4.46047 10.5562 4.12763 10.5562 3.71705C10.5562 3.30647 10.2233 2.97363 9.81276 2.97363C9.40218 2.97363 9.06934 3.30647 9.06934 3.71705C9.06934 4.12763 9.40218 4.46047 9.81276 4.46047Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81276 14.8684C10.2233 14.8684 10.5562 14.5356 10.5562 14.125C10.5562 13.7144 10.2233 13.3816 9.81276 13.3816C9.40218 13.3816 9.06934 13.7144 9.06934 14.125C9.06934 14.5356 9.40218 14.8684 9.81276 14.8684Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Tick = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13 26.3638C20.0416 26.3638 25.75 20.666 25.75 13.6375C25.75 6.60891 20.0416 0.911133 13 0.911133C5.95837 0.911133 0.25 6.60891 0.25 13.6375C0.25 20.666 5.95837 26.3638 13 26.3638ZM12.351 18.5205L19.4343 10.0362L17.899 8.75448L11.5162 16.3997L8.03978 12.9297L6.62688 14.3452L10.8769 18.5874L11.6505 19.3595L12.351 18.5205Z"
        fill="#0868AA"
      />
    </svg>
  );
};
export const CloseBlackIcon = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.75 13.3963C25.75 20.4248 20.0416 26.1226 13 26.1226C5.95837 26.1226 0.25 20.4248 0.25 13.3963C0.25 6.3677 5.95837 0.669922 13 0.669922C20.0416 0.669922 25.75 6.3677 25.75 13.3963ZM6.62557 19.7589C6.23468 19.3687 6.23468 18.7361 6.62557 18.346L11.5845 13.3963L6.62557 8.44656C6.23468 8.0564 6.23468 7.42382 6.62557 7.03366C7.01646 6.6435 7.65021 6.6435 8.0411 7.03366L13 11.9834L17.9589 7.03366C18.3498 6.6435 18.9835 6.6435 19.3744 7.03366C19.7653 7.42383 19.7653 8.0564 19.3744 8.44656L14.4155 13.3963L19.3744 18.346C19.7653 18.7361 19.7653 19.3687 19.3744 19.7589C18.9835 20.149 18.3498 20.149 17.9589 19.7589L13 14.8092L8.0411 19.7589C7.65021 20.149 7.01646 20.149 6.62557 19.7589Z"
        fill="black"
      />
    </svg>
  );
};

export const Link = ({ fillColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 16H7C4.79086 16 3 14.2091 3 12V12C3 9.79086 4.79086 8 7 8H10"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12H8"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16H17C19.2091 16 21 14.2091 21 12V12C21 9.79086 19.2091 8 17 8H14"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Dollar = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8751 7.125C12.1735 7.125 12.4596 7.00647 12.6706 6.7955C12.8816 6.58452 13.0001 6.29837 13.0001 6V5.48475C12.9987 4.42836 12.5784 3.41563 11.8314 2.66864C11.0845 1.92166 10.0717 1.50139 9.01534 1.5H8.12509V1.125C8.12509 0.826631 8.00656 0.540483 7.79558 0.329505C7.58461 0.118526 7.29846 0 7.00009 0C6.70172 0 6.41557 0.118526 6.20459 0.329505C5.99362 0.540483 5.87509 0.826631 5.87509 1.125V1.5H4.98484C4.0282 1.49857 3.10297 1.84136 2.37818 2.46573C1.65338 3.0901 1.1774 3.95438 1.03719 4.90069C0.896968 5.847 1.10187 6.81217 1.61447 7.61989C2.12707 8.42761 2.91314 9.02396 3.82909 9.3L5.87509 9.8595V14.25H4.98484C4.52494 14.2494 4.08404 14.0664 3.75884 13.7412C3.43364 13.416 3.25068 12.9752 3.25009 12.5153V12C3.25009 11.7016 3.13156 11.4155 2.92058 11.2045C2.70961 10.9935 2.42346 10.875 2.12509 10.875C1.82672 10.875 1.54057 10.9935 1.32959 11.2045C1.11861 11.4155 1.00009 11.7016 1.00009 12V12.5153C1.00148 13.5716 1.42174 14.5844 2.16873 15.3314C2.91571 16.0783 3.92844 16.4986 4.98484 16.5H5.87509V16.875C5.87509 17.1734 5.99362 17.4595 6.20459 17.6705C6.41557 17.8815 6.70172 18 7.00009 18C7.29846 18 7.58461 17.8815 7.79558 17.6705C8.00656 17.4595 8.12509 17.1734 8.12509 16.875V16.5H9.01534C9.97198 16.5014 10.8972 16.1586 11.622 15.5343C12.3468 14.9099 12.8228 14.0456 12.963 13.0993C13.1032 12.153 12.8983 11.1878 12.3857 10.3801C11.8731 9.57239 11.087 8.97604 10.1711 8.7L8.12509 8.142V3.75H9.01534C9.47524 3.7506 9.91613 3.93355 10.2413 4.25875C10.5665 4.58395 10.7495 5.02485 10.7501 5.48475V6C10.7501 6.29837 10.8686 6.58452 11.0796 6.7955C11.2906 7.00647 11.5767 7.125 11.8751 7.125ZM9.53659 10.8593C9.93225 10.9839 10.2702 11.2462 10.4891 11.5986C10.708 11.951 10.7935 12.3701 10.73 12.7801C10.6665 13.19 10.4583 13.5637 10.1431 13.8333C9.82784 14.103 9.42643 14.2508 9.01159 14.25H8.12509V10.4738L9.53659 10.8593ZM5.87509 7.52625L4.46359 7.14075C4.06824 7.01616 3.73054 6.75418 3.51159 6.4022C3.29264 6.05023 3.2069 5.63151 3.26988 5.2218C3.33286 4.8121 3.54041 4.43847 3.85497 4.16851C4.16953 3.89855 4.57032 3.75009 4.98484 3.75H5.87509V7.52625Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const AddSquare = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 9.99976C2.5 6.71227 2.5 5.06853 3.40796 3.96218C3.57418 3.75965 3.75989 3.57393 3.96243 3.40771C5.06878 2.49976 6.71252 2.49976 10 2.49976V2.49976C13.2875 2.49976 14.9312 2.49976 16.0376 3.40771C16.2401 3.57393 16.4258 3.75965 16.592 3.96218C17.5 5.06853 17.5 6.71227 17.5 9.99976V9.99976C17.5 13.2872 17.5 14.931 16.592 16.0373C16.4258 16.2399 16.2401 16.4256 16.0376 16.5918C14.9312 17.4998 13.2875 17.4998 10 17.4998V17.4998C6.71252 17.4998 5.06878 17.4998 3.96243 16.5918C3.75989 16.4256 3.57418 16.2399 3.40796 16.0373C2.5 14.931 2.5 13.2872 2.5 9.99976V9.99976Z"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M10 6.66644L10 13.3331"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 9.99976L6.66634 9.99976"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Edit = ({ fillColor, width, height, handleClick }) => {
  return (
    <svg
      onClick={() => handleClick()}
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.16289 9.02561L2.16289 9.02561C2.026 9.26737 1.96094 9.53104 1.90953 9.73934C1.90487 9.75825 1.90031 9.77671 1.89583 9.79465L1.39896 11.7821C1.39616 11.7933 1.39324 11.8049 1.39022 11.8169C1.3534 11.9634 1.3024 12.1663 1.28483 12.3459C1.26461 12.5526 1.25792 13.0046 1.6267 13.3734C1.99548 13.7422 2.44744 13.7355 2.65413 13.7153C2.83375 13.6977 3.03666 13.6467 3.18315 13.6099C3.19515 13.6068 3.20678 13.6039 3.21798 13.6011L5.20543 13.1043C5.22337 13.0998 5.24182 13.0952 5.26073 13.0906C5.46904 13.0391 5.7327 12.9741 5.97447 12.8372L5.97448 12.8372C6.21624 12.7003 6.40768 12.5077 6.55893 12.3555C6.57267 12.3417 6.58607 12.3282 6.59915 12.3151L12.4574 6.45686C12.4671 6.44716 12.4768 6.43746 12.4865 6.42778C12.7156 6.1988 12.9385 5.97597 13.106 5.76954C13.2916 5.5408 13.4819 5.24751 13.5529 4.86253L12.5695 4.68114L13.5529 4.86252C13.5972 4.6227 13.5972 4.37681 13.5529 4.13699L12.5695 4.31837L13.5529 4.13698C13.4819 3.752 13.2916 3.45872 13.106 3.22997C12.9385 3.02356 12.7156 2.80073 12.4866 2.57177C12.4769 2.56208 12.4672 2.55237 12.4574 2.54265L11.7503 3.24976L12.4574 2.54265C12.4477 2.53294 12.438 2.52324 12.4283 2.51356C12.1994 2.28451 11.9765 2.06161 11.7701 1.8941C11.5414 1.70849 11.2481 1.51815 10.8631 1.44715C10.6233 1.40291 10.3774 1.40291 10.1376 1.44715C9.75257 1.51815 9.45929 1.70849 9.23054 1.8941C9.02412 2.0616 8.80129 2.2845 8.57232 2.51354C8.56263 2.52323 8.55293 2.53294 8.54322 2.54265L2.68493 8.40094C2.67186 8.41401 2.65838 8.42741 2.64456 8.44114C2.49239 8.59239 2.29978 8.78384 2.16289 9.02561Z"
        stroke={fillColor}
        strokeWidth="2"
      />
    </svg>
  );
};

export const CloseRing = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.4998C9.01509 17.4998 8.03982 17.3058 7.12987 16.9289C6.21993 16.5519 5.39314 15.9995 4.6967 15.3031C4.00026 14.6066 3.44781 13.7798 3.0709 12.8699C2.69399 11.9599 2.5 10.9847 2.5 9.99975C2.5 9.01484 2.69399 8.03957 3.0709 7.12963C3.44781 6.21969 4.00026 5.39289 4.6967 4.69645C5.39314 4.00001 6.21993 3.44757 7.12988 3.07066C8.03982 2.69375 9.01509 2.49976 10 2.49976C10.9849 2.49976 11.9602 2.69375 12.8701 3.07066C13.7801 3.44757 14.6069 4.00002 15.3033 4.69646C15.9997 5.3929 16.5522 6.21969 16.9291 7.12963C17.306 8.03957 17.5 9.01484 17.5 9.99976C17.5 10.9847 17.306 11.9599 16.9291 12.8699C16.5522 13.7798 15.9997 14.6066 15.3033 15.3031C14.6069 15.9995 13.7801 16.5519 12.8701 16.9289C11.9602 17.3058 10.9849 17.4998 10 17.4998L10 17.4998Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.5 7.49976L12.5 12.4998"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.5 7.49976L7.5 12.4998"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Paper = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2.50001V2.50001C16.3807 2.50001 17.5 3.61929 17.5 5.00001L17.5 6.78572C17.5 6.98521 17.5 7.08495 17.4719 7.16514C17.4217 7.30876 17.3088 7.42169 17.1651 7.47194C17.085 7.5 16.9852 7.5 16.7857 7.5L12.5 7.5M15 2.50001V2.50001C13.6193 2.50001 12.5 3.61929 12.5 5.00001L12.5 7.5M15 2.50001L6.5 2.50001C4.61438 2.50001 3.67157 2.50001 3.08579 3.08579C2.5 3.67158 2.5 4.61439 2.5 6.50001L2.5 17.5L5 16.6667L7.5 17.5L10 16.6667L12.5 17.5L12.5 7.5"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M5.83398 5.83325L9.16732 5.83325"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.66602 9.16675H5.83268"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.83398 12.5L8.33398 12.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PeparIcon = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2.50001V2.50001C16.3807 2.50001 17.5 3.61929 17.5 5.00001L17.5 6.78572C17.5 6.98521 17.5 7.08495 17.4719 7.16514C17.4217 7.30876 17.3088 7.42169 17.1651 7.47194C17.085 7.5 16.9852 7.5 16.7857 7.5L12.5 7.5M15 2.50001V2.50001C13.6193 2.50001 12.5 3.61929 12.5 5.00001L12.5 7.5M15 2.50001L6.5 2.50001C4.61438 2.50001 3.67157 2.50001 3.08579 3.08579C2.5 3.67158 2.5 4.61439 2.5 6.50001L2.5 17.5L5 16.6667L7.5 17.5L10 16.6667L12.5 17.5L12.5 7.5"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M5.83398 5.83325L9.16732 5.83325"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.66602 9.16675H5.83268"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.83398 12.5L8.33398 12.5"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const WatchListIcon = ({ fillColor }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="3.33325"
        width="10.8333"
        height="14.1667"
        rx="2"
        stroke={fillColor}
        strokeWidth="2"
      />
      <path
        d="M12.5 8.33325V6.66659"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.33337 7.5H6.66671"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.33337 10.8333H6.66671"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.33337 14.1667H6.66671"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Member = ({ fillColor }) => {
  return (
    <svg
      width="38"
      height="32"
      viewBox="0 0 38 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_299_2124)">
        <path
          d="M14.7812 29.6172V28.029C14.7812 27.1865 14.4148 26.3786 13.7625 25.7829C13.1103 25.1872 12.2256 24.8525 11.3032 24.8525H4.34715C3.42473 24.8525 2.54008 25.1872 1.88783 25.7829C1.23557 26.3786 0.869141 27.1865 0.869141 28.029V29.6172"
          stroke="#0B6AAB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.82567 21.6761C9.74652 21.6761 11.3037 20.254 11.3037 18.4997C11.3037 16.7454 9.74652 15.3232 7.82567 15.3232C5.90482 15.3232 4.34766 16.7454 4.34766 18.4997C4.34766 20.254 5.90482 21.6761 7.82567 21.6761Z"
          stroke="#0B6AAB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.9982 29.6175V28.0293C19.9976 27.3255 19.7411 26.6418 19.269 26.0855C18.7968 25.5293 18.1358 25.132 17.3896 24.9561"
          stroke="#0B6AAB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.9121 15.4263C14.6602 15.6012 15.3233 15.9986 15.7969 16.5557C16.2704 17.1129 16.5274 17.7981 16.5274 18.5035C16.5274 19.2088 16.2704 19.894 15.7969 20.4512C15.3233 21.0083 14.6602 21.4057 13.9121 21.5806"
          stroke="#0B6AAB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <rect x="17.8867" width="19.3775" height="19.3775" fill={fillColor} />
      <path
        d="M24.6147 12.0307C24.7107 13.3147 25.5987 14.5027 27.4587 14.5027C29.7747 14.5027 30.4347 12.8947 30.4347 9.91872C30.4347 7.14672 29.7027 5.53872 27.3267 5.53872C25.4787 5.53872 24.3747 6.69072 24.3747 8.44272C24.3747 10.2907 25.5867 11.2387 27.0987 11.2387C27.8667 11.2387 28.5747 10.9387 28.9467 10.4227C28.9467 12.3907 28.5147 13.1227 27.5307 13.1227C26.7507 13.1227 26.3067 12.7267 26.1747 12.0307H24.6147ZM27.4467 9.87072C26.4267 9.87072 25.9827 9.22272 25.9827 8.43072C25.9827 7.55472 26.5107 6.96672 27.3867 6.96672C28.2387 6.96672 28.7907 7.49472 28.7907 8.45472C28.7907 9.30672 28.2867 9.87072 27.4467 9.87072Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_299_2124">
          <rect
            width="20.8681"
            height="19.0587"
            fill="white"
            transform="translate(0 12.9409)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RightClick = ({ fillColor }) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 9.38462L4.9254 11.5787C5.35409 11.9002 5.96002 11.8266 6.29935 11.4119L14 2"
        stroke={fillColor}
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const InfoIcon = ({ fillColor, customClass }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M17.1706 27.3101C18.7872 27.025 20.3318 26.4244 21.7162 25.5424C23.1007 24.6604 24.2979 23.5144 25.2394 22.1697C26.1809 20.825 26.8484 19.3081 27.2037 17.7055C27.559 16.1029 27.5951 14.446 27.3101 12.8294C27.025 11.2128 26.4244 9.6682 25.5424 8.28375C24.6604 6.89931 23.5144 5.70214 22.1697 4.7606C20.825 3.81906 19.3081 3.15159 17.7055 2.7963C16.1029 2.44101 14.446 2.40486 12.8294 2.6899C11.2128 2.97495 9.6682 3.57562 8.28375 4.45761C6.89931 5.3396 5.70214 6.48564 4.7606 7.8303C3.81906 9.17495 3.15159 10.6919 2.7963 12.2945C2.44101 13.8971 2.40486 15.554 2.6899 17.1706C2.97495 18.7872 3.57562 20.3318 4.45761 21.7162C5.3396 23.1007 6.48564 24.2979 7.8303 25.2394C9.17495 26.1809 10.6919 26.8484 12.2945 27.2037C13.8971 27.559 15.554 27.5951 17.1706 27.3101L17.1706 27.3101Z"
        stroke={fillColor}
        stroke-width="2"
      />
      <path
        d="M15 15L15 22.5"
        stroke={fillColor}
        stroke-width="2"
        stroke-linecap="square"
      />
      <path
        d="M15 8.75L15 7.5"
        stroke={fillColor}
        stroke-width="2"
        stroke-linecap="square"
      />
    </svg>
  );
};

export const Chart = ({ fillColor, customClass }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M21.25 11.25L17.2058 17.3162C16.7799 17.9551 15.8228 17.8955 15.4794 17.2087L14.5206 15.2913C14.1772 14.6045 13.2201 14.5449 12.7942 15.1838L8.75 21.25"
        stroke={fillColor}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3.75"
        y="3.75"
        width="22.5"
        height="22.5"
        rx="2"
        stroke={fillColor}
        stroke-width="2"
      />
    </svg>
  );
};

export const Chart2 = ({ fillColor, customClass }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M10 12.5L10 20"
        stroke={fillColor}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 15V20"
        stroke={fillColor}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 10V20"
        stroke={fillColor}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3.75"
        y="5"
        width="22.5"
        height="20"
        rx="2"
        stroke={fillColor}
        stroke-width="2"
      />
    </svg>
  );
};

export const Round = ({ fillColor, customClass }) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <circle cx="5.5" cy="5.5" r="5.5" fill={fillColor} />
    </svg>
  );
};

export const Question = ({ fillColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke={fillColor} stroke-width="2" />
      <circle cx="12" cy="18" r="0.5" fill={fillColor} stroke={fillColor} />
      <path
        d="M12 16V14.5811C12 13.6369 12.6042 12.7986 13.5 12.5V12.5C14.3958 12.2014 15 11.3631 15 10.4189V9.90569C15 8.30092 13.6991 7 12.0943 7H12C10.3431 7 9 8.34315 9 10V10"
        stroke={fillColor}
        stroke-width="2"
      />
    </svg>
  );
};

export const CheckRound = ({ fillColor, width, height, customclass }) => {
  return (
    <svg
      className={customclass}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.7682 6.64018C14.1218 6.21591 14.0645 5.58534 13.6402 5.23178C13.2159 4.87821 12.5853 4.93554 12.2318 5.35982L8.63383 9.67736C8.28711 10.0934 8.09219 10.3238 7.93658 10.4653L7.93063 10.4707L7.92422 10.4659C7.75643 10.339 7.54146 10.1272 7.1585 9.74428L5.70711 8.29289C5.31658 7.90237 4.68342 7.90237 4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L5.74428 11.1585L5.78511 11.1993L5.78512 11.1993C6.11161 11.526 6.4257 11.8402 6.71794 12.0611C7.0453 12.3087 7.47402 12.5415 8.02343 12.5165C8.57284 12.4916 8.97872 12.221 9.28233 11.9448C9.55337 11.6983 9.83772 11.3569 10.1333 11.0021L10.1333 11.0021L10.1703 10.9577L13.7682 6.64018Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const InactiveCheckRound = ({
  fillColor,
  width,
  height,
  customclass,
}) => {
  return (
    <svg
      className={customclass}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929L7.58579 9L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9 7.58579L12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289C14.0976 4.68342 14.0976 5.31658 13.7071 5.70711L10.4142 9L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L9 10.4142L5.70711 13.7071C5.31658 14.0976 4.68342 14.0976 4.29289 13.7071Z"
        fill={fillColor}
      />
    </svg>
    // #969BA0
  );
};
